import { Layer, Source } from "@vis.gl/react-maplibre";
import { FC, useMemo } from "react";

import {
  DRAW_POLYLINE_DASH_ARRAY,
  DRAW_POLYLINE_OPACITY_ACTIVE,
  DRAW_POLYLINE_OPACITY_INACTIVE,
  DRAW_POLYLINE_WEIGHT_ACTIVE,
  DRAW_POLYLINE_WEIGHT_INACTIVE,
} from "@ryde/controls";
import {
  latLngTuplesToLineStringFeature,
  leafletDashToMapLibreDashArray,
  TLatLngTuple,
} from "@ryde/shared";

import { MIN_LINE_POINTS } from "../route-block-maplibre.constants";
import { MapLibreRouteArrows } from "./maplibre-route-arrows";

/**
 * The course's saved route. Thinned and dashed while a new line is being drawn over it, so it reads as the
 * "before" rather than competing with the drawing; direction arrows are dropped then for the same reason.
 */
export const MapLibreCourseRouteLine: FC<{
  positions: TLatLngTuple[];
  colorValue: string;
  isDrawing: boolean;
}> = ({ positions, colorValue, isDrawing }) => {
  const feature = useMemo(
    () => latLngTuplesToLineStringFeature(positions),
    [positions],
  );

  if (positions.length < MIN_LINE_POINTS) {
    return null;
  }

  return (
    <Source id="maplibre-course-route" type="geojson" data={feature}>
      <Layer
        id="maplibre-course-route-line"
        type="line"
        paint={{
          ["line-color"]: colorValue,
          ["line-width"]: isDrawing
            ? DRAW_POLYLINE_WEIGHT_ACTIVE
            : DRAW_POLYLINE_WEIGHT_INACTIVE,
          ["line-opacity"]: isDrawing
            ? DRAW_POLYLINE_OPACITY_ACTIVE
            : DRAW_POLYLINE_OPACITY_INACTIVE,
          ...(isDrawing
            ? {
                ["line-dasharray"]: leafletDashToMapLibreDashArray(
                  DRAW_POLYLINE_DASH_ARRAY,
                  DRAW_POLYLINE_WEIGHT_ACTIVE,
                ),
              }
            : {}),
        }}
      />

      {!isDrawing && <MapLibreRouteArrows color={colorValue} />}
    </Source>
  );
};
